import React from "react";
import { useLanguage } from "../../Language";
import { Alert } from "@mui/material";
import { ConfirmDialog } from "@tlc/ui/dialog/ConfirmDialog";

interface RenewLoansDialogProps {
  open: boolean;
  onClose: () => void;
  failedRenewals: string[];
}

export default function RenewLoansErrorDialog({
  open,
  onClose,
  failedRenewals,
}: RenewLoansDialogProps) {
  const { translate } = useLanguage();

  return (
    <ConfirmDialog
      id="renew-loans-error-dialog"
      useSingleAction={true}
      confirmButtonText={translate("ok")}
      onConfirm={() => {}}
      open={open}
      onClose={onClose}
      headline={translate("errorDialogTitle")}
    >
      <div>
        <Alert severity="error">{translate("loanRenewError")}</Alert>
        <ul style={{ padding: "16px 0px 0px 0px" }}>
          {failedRenewals.map((title, index) => (
            <li key={index}>{title}</li>
          ))}
        </ul>
      </div>
    </ConfirmDialog>
  );
}
